import React from 'react';
import SimpleModal from './SimpleModal/SimpleModal'
import {default as ModalV2}  from './v2/modal' 
import Default from './Modal'
import Dialog from './Dialog'

const Modal = (props) => {

    const setVariant = (variant) => {

        switch (variant) { 
            case 'default': return <Default {...props} />
            case 'v2': return <ModalV2 {...props} />
            case 'dialog': return <Dialog {...props} />
            default:
            case 'simple': return <SimpleModal {...props} />
        }

    }

    return setVariant(props.variant)

}

export {
    SimpleModal,
    ModalV2
}

export default Modal